import { StateType } from '../../../../states';
import { selectGRGlobalSkinId } from '../../selectors/global/globalPrimary.selector';

const selectGRIconProps = (state: StateType) => {
  const skinId = selectGRGlobalSkinId(state);

  return {
    skinId,
  };
};

export default selectGRIconProps;
